"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInfoSection = void 0;
const ui_1 = require("@app/component/ui");
const dropdown_input_1 = require("@app/component/ui/forms/dropdown-input/dropdown-input");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_1 = require("@app/util/functional/maybe");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const shift_context_1 = require("../shift-context");
const get_contract_options_1 = require("../util/get-contract-options");
const BaseInfoSection = () => {
    const { formControl, formType, getValues, initialData, disabledEditation, transferStatus, transferRole, transferMaster, copiesCount, setCopiesCount, } = (0, shift_context_1.useShift)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const contractTypes = new maybe_1.Maybe(workspace?.contractTypes?.filter(util_1.isValue)).get(() => []);
    const shift = (0, store_1.useRootSelector)((state) => state.shifts.find((sh) => sh.id === initialData?.shiftId));
    const selectedEmployeeId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'user' });
    const employees = (0, store_1.useRootSelector)((state) => Object.values(state.employees).filter((emp) => transferRole === 'master' || !emp.external));
    let employeeOptions = react_1.default.useMemo(() => employees.map((emp) => ({ value: emp.id ?? '', label: emp.name })), [employees]);
    if (initialData?.transferDetails) {
        const { employeeFirstname, employeeLastname } = initialData.transferDetails;
        if (employeeFirstname && employeeLastname) {
            const name = employeeLastname + ' ' + employeeFirstname;
            employeeOptions = [
                {
                    value: selectedEmployeeId,
                    label: name,
                },
            ];
        }
    }
    const selectedEmployee = employees.find((emp) => emp.id === selectedEmployeeId);
    // const periodStart = useWatch({ control: formControl, name: 'period.start' })
    // const periodEnd = useWatch({ control: formControl, name: 'period.end' })
    const periodStartController = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'period.start',
    });
    const periodStart = periodStartController.field.value.clone();
    const periodEndController = (0, react_hook_form_1.useController)({
        control: formControl,
        name: 'period.end',
    });
    const periodEnd = periodEndController.field.value.clone();
    const contractOptions = (0, get_contract_options_1.getContractOptions)(shift, selectedEmployee?.contracts, contractTypes, periodStart);
    const positions = (0, store_1.useRootSelector)((state) => state.positions);
    const positionsOnWS = transferStatus === 'accepted' || transferStatus === 'pending'
        ? positions
        : positions.filter((p) => !p.archived);
    let positionOptions = react_1.default.useMemo(() => new maybe_1.Maybe(positionsOnWS)
        .map((_positions) => _positions
        .map((p) => ({ ...p, name: p.name ?? '-' }))
        .map((p) => ({ value: p.id ?? '', label: react_1.default.createElement(ui_1.Position, { pos: p }) })))
        .get(() => []), [positionsOnWS]);
    if (transferRole === 'slave' && transferMaster?.positionName) {
        positionOptions = [
            {
                value: getValues().position,
                label: react_1.default.createElement(ui_1.Position, { pos: { name: transferMaster.positionName } }),
            },
        ];
    }
    const isShiftLive = formType === 'live';
    const isOffers = initialData?.isOffersOrUnassigned === 'offers' ||
        initialData?.isOffersOrUnassigned === 'unassigned';
    const isUnassigned = initialData?.isOffersOrUnassigned === 'unassigned';
    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '1rem' } },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            !isOffers ? (react_1.default.createElement(dropdown_input_1.DropdownInput, { options: employeeOptions, label: (0, util_1.t)('EMPLOYEE'), control: formControl, name: 'user', disabled: !isShiftLive ||
                    (0, util_1.isDefined)(disabledEditation) ||
                    transferRole === 'master', searchableOptions: true })) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ui_1.Input, { type: 'number', size: 'full-width', label: (0, util_1.t)('HOW_MANY_COPIES'), value: copiesCount, onChange: (v) => {
                        if (Number.isNaN(Number(v)))
                            return;
                        setCopiesCount(parseInt(v));
                    } }),
                isOffers || isUnassigned ? react_1.default.createElement("div", null) : null)),
            react_1.default.createElement(ui_1.Input, { label: (0, util_1.t)('DATE'), type: 'date', size: 'full-width', value: periodStart.format('YYYY-MM-DD'), onChange: (newValue) => {
                    const newDate = newValue ? (0, moment_1.default)(newValue, 'YYYY-MM-DD') : null;
                    if (!newDate)
                        return;
                    const newStart = (0, moment_1.default)(newDate)
                        .set('hour', periodStart.hour())
                        .set('minutes', periodStart.minute());
                    periodStartController.field.onChange(newStart);
                    const newEnd = (0, moment_1.default)(newDate)
                        .set('hour', periodEnd.hour())
                        .set('minutes', periodEnd.minute());
                    periodEndController.field.onChange(newEnd.isSameOrBefore(newStart) ? newEnd.add(1, 'day') : newEnd);
                }, name: 'date', disabled: !isShiftLive || (0, util_1.isDefined)(disabledEditation) || transferRole === 'master', hasError: (0, util_1.isValue)(periodStartController.fieldState.error) ||
                    (0, util_1.isValue)(periodEndController.fieldState.error), errorMessage: periodStartController.fieldState.error?.message ??
                    periodEndController.fieldState.error?.message }),
            isOffers || isUnassigned ? react_1.default.createElement("div", null) : null,
            react_1.default.createElement(ui_1.Input, { type: 'time', name: 'shiftStart', label: (0, util_1.t)('SHIFT_START'), size: 'full-width', value: periodStart.format('HH:mm'), disabled: (0, util_1.isDefined)(disabledEditation), onChange: (newValue) => {
                    const newTime = newValue ? (0, moment_1.default)(newValue, 'HH:mm') : null;
                    if (!newTime)
                        return;
                    const newStart = (0, moment_1.default)(periodStart).set({
                        hour: newTime.hour(),
                        minute: newTime.minute(),
                    });
                    periodStartController.field.onChange((0, moment_1.default)(newStart));
                    const newEnd = (0, moment_1.default)(newStart)
                        .set('hour', periodEnd.hour())
                        .set('minutes', periodEnd.minute());
                    periodEndController.field.onChange(newEnd.isSameOrBefore(newStart) ? newEnd.add(1, 'day') : newEnd);
                } }),
            react_1.default.createElement(ui_1.Input, { type: 'time', name: 'shiftEnd', label: (0, util_1.t)('SHIFT_END'), size: 'full-width', value: periodEnd.format('HH:mm'), disabled: (0, util_1.isDefined)(disabledEditation), onChange: (newValue) => {
                    const newTime = newValue ? (0, moment_1.default)(newValue, 'HH:mm') : null;
                    if (!newTime)
                        return;
                    const newEnd = (0, moment_1.default)(periodEnd).set({
                        hour: newTime.hour(),
                        minute: newTime.minute(),
                    });
                    if ((0, moment_1.default)(newEnd).subtract(1, 'day').isAfter(periodStart)) {
                        periodEndController.field.onChange((0, moment_1.default)(newEnd).subtract(1, 'day'));
                    }
                    else {
                        periodEndController.field.onChange((0, moment_1.default)(newEnd).isSameOrBefore(periodStart)
                            ? (0, moment_1.default)(newEnd).add(1, 'day')
                            : (0, moment_1.default)(newEnd));
                    }
                } }),
            react_1.default.createElement(dropdown_input_1.DropdownInput, { options: positionOptions, label: (0, util_1.t)('POSITION'), control: formControl, name: 'position', disabled: (0, util_1.isDefined)(disabledEditation) || transferRole === 'master', rules: {
                    required: { value: true, message: (0, util_1.t)('FORM_ERR_MISSING_REQUIRED') },
                }, searchableOptions: true }),
            transferRole === 'master' || isOffers ? (false) : (react_1.default.createElement(dropdown_input_1.DropdownInput, { options: contractOptions, label: (0, util_1.t)('AGREEMENT'), control: formControl, name: 'contractId', disabled: disabledEditation === 'disabled-due-to-transfer'
                    ? transferStatus === 'pending'
                    : (0, util_1.isDefined)(disabledEditation) || !isShiftLive })))));
};
exports.BaseInfoSection = BaseInfoSection;
